(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/expanded-systems/assets/javascripts/system-num-mapping.js') >= 0) return;  svs.modules.push('/components/sport/expanded-systems/assets/javascripts/system-num-mapping.js'); "use strict";

var systemNumMapping = {
  33: 'R0-7-16',
  34: 'R0-11-16',
  35: 'R2-5-12',
  36: 'R3-3-24',
  37: 'R4-0-9',
  38: 'R4-4-24',
  39: 'R4-4-144',
  40: 'R4-5-48',
  41: 'R4-6-24',
  42: 'R4-6-72',
  43: 'R4-7-48',
  44: 'R4-7-144',
  45: 'R5-0-18',
  46: 'R5-3-36',
  47: 'R5-5-108',
  48: 'R6-3-24',
  49: 'R6-3-72',
  50: 'R6-4-44',
  28: 'R7-0-36',
  51: 'R7-2-34',
  52: 'R7-2-108',
  53: 'R8-0-27',
  29: 'R8-0-81',
  54: 'R8-2-324',
  30: 'R9-0-222',
  56: 'R9-0-243',
  58: 'R10-0-153',
  31: 'R10-0-567',
  32: 'R11-0-729',
  59: 'U0-7-10',
  60: 'U0-10-38',
  61: 'U0-11-65',
  62: 'U3-6-20',
  63: 'U3-6-50',
  64: 'U3-7-98',
  65: 'U4-3-66',
  66: 'U4-4-16',
  67: 'U4-4-44',
  68: 'U4-5-30',
  69: 'U4-5-68',
  70: 'U4-7-200',
  71: 'U5-5-44',
  72: 'U5-5-176',
  73: 'U5-6-274',
  74: 'U6-3-36',
  75: 'U6-4-66',
  76: 'U6-4-224',
  77: 'U7-3-100',
  78: 'U7-4-464',
  79: 'U8-2-253',
  81: 'U8-3-598',
  82: 'U9-2-202',
  83: 'U11-0-133',
  84: 'U13-0-105'
};
setGlobal('svs.sport.expandedSystems.systemNumMapping', systemNumMapping);
 })(window);